var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCameriaFill = function SvgCameriaFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5q1.875 0 3.188-1.312Q16.5 14.875 16.5 13t-1.312-3.187T12 8.5 8.813 9.813Q7.499 11.125 7.5 13q0 1.875 1.313 3.188Q10.125 17.5 12 17.5m0-2q-1.05 0-1.775-.725T9.5 13t.725-1.775T12 10.5t1.775.725T14.5 13t-.725 1.775T12 15.5M4 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19V7q0-.824.587-1.412A1.93 1.93 0 0 1 4 5h3.15L8.4 3.65q.275-.3.662-.475Q9.45 3 9.876 3h4.25q.424 0 .813.175.387.175.662.475L16.85 5H20q.824 0 1.413.588Q22 6.175 22 7v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCameriaFill);
export { ForwardRef as ReactComponent };